import produce from 'immer';
import { basePspBranchActions } from '../actions';
import { PspBranchResponse, PspResponse, BranchListItemResponse } from '../../../api';

export interface PspBranchState {
  pspData: {
    data: { message: string; data: PspResponse } | undefined;
    ok: boolean | undefined;
    updateCrud: boolean | undefined;
  };
  pspBranch: {
    data: Array<BranchListItemResponse> | undefined;
    ok: boolean | undefined;
    crud: boolean | undefined;
  };
  currentBranch: {
    data: PspBranchResponse | undefined;
    ok: boolean | undefined;
  };
  branchFilter: {
    filterActive: boolean;
  };
}

export const INITIAL_PSP_BRANCH_STATE: PspBranchState = {
  pspData: {
    data: undefined,
    ok: undefined,
    updateCrud: undefined,
  },
  pspBranch: {
    data: undefined,
    ok: undefined,
    crud: undefined,
  },
  currentBranch: {
    data: undefined,
    ok: undefined,
  },
  branchFilter: {
    filterActive: true,
  },
};

export function BasePspBranchReducer(state: PspBranchState = INITIAL_PSP_BRANCH_STATE, action: any): any {
  return produce(state, (draftState) => {
    switch (action.type) {
      case basePspBranchActions.loadPspBranchList.type:
        draftState.pspBranch.ok = undefined;
        return;

      case basePspBranchActions.setPspBranchList.type:
        draftState.pspBranch.data = action.payload;
        return;

      case basePspBranchActions.successPspBranchList.type:
        draftState.pspBranch.ok = true;
        return;

      case basePspBranchActions.errorPspBranchList.type:
        draftState.pspBranch.ok = false;
        return;

      case basePspBranchActions.setPspBranchActiveCrud.type:
        draftState.pspBranch.crud = undefined;
        return;

      case basePspBranchActions.successPspBranchCrud.type:
        draftState.pspBranch.crud = true;
        return;

      case basePspBranchActions.errorPspBranchCrud.type:
        draftState.pspBranch.crud = false;
        return;

      case basePspBranchActions.loadBranch.type:
        draftState.currentBranch.ok = undefined;
        return;

      case basePspBranchActions.setBranch.type:
        draftState.currentBranch.data = action.payload;
        return;

      case basePspBranchActions.successBranch.type:
        draftState.currentBranch.ok = true;
        return;

      case basePspBranchActions.errorBranch.type:
        draftState.currentBranch.ok = false;
        return;

      case basePspBranchActions.resetBranch.type:
        draftState.currentBranch.data = undefined;
        draftState.currentBranch.ok = undefined;
        return;

      case basePspBranchActions.setBranchInactiveFilter.type:
        draftState.branchFilter.filterActive = action.filterActive;
        return;
    }
  });
}
